import { css } from '@emotion/react'
import { BackToOriginButton } from 'components/back-to-origin-button/BackToOriginButton'
import { BackToOriginUrlParams } from 'components/back-to-origin-button/backToOriginButton-model'
import { isBackToOriginKeyEnabled } from 'components/back-to-origin-button/backToOriginButton-utils'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContainer } from 'components/layout/PageContainer'
import { useFlags } from 'config/useFlagsContext'
import { useBuscaDetailCidadaoQuery } from 'graphql/hooks.generated'
import { useUrlQueryParams } from 'hooks/useUrlQueryParams'
import qs from 'qs'
import { Fragment } from 'react'
import { useLocation, useRouteMatch } from 'react-router'

import { CidadaoUrlParams } from '../types/cidadao-urlParams'
import { CidadaoCabecalhoSection } from './components/CidadaoCabecalhoSection'
import { CidadaoTabSection } from './components/CidadaoTabSection'

interface UrlParams {
  cidadaoId: string
}

export function CidadaoVisualizacaoView() {
  const match = useRouteMatch<UrlParams>()
  const location = useLocation()
  const { data } = useBuscaDetailCidadaoQuery({ variables: { id: match.params.cidadaoId } })

  const cidadaoUrlParams: CidadaoUrlParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  })
  const flags = useFlags()
  const { backToOriginUrl, backToOriginKey } = useUrlQueryParams<BackToOriginUrlParams>()

  const showBotaoRetornar = !!backToOriginUrl && isBackToOriginKeyEnabled(flags, backToOriginKey)

  const showActionButtons = !cidadaoUrlParams.callbackUrl

  return (
    <Fragment>
      <Breadcrumb title='Visualização do cadastro' />
      {data?.cidadao && (
        <Fragment>
          <PageContainer fluid>
            {showBotaoRetornar && (
              <BackToOriginButton
                style={css`
                  margin-top: 0.5rem;
                `}
              />
            )}

            <CidadaoCabecalhoSection
              cidadao={data.cidadao}
              sizeBotaoAtualizar='medium'
              botaoExcluirCidadao={showActionButtons}
              botaoSelecionar={!showActionButtons}
              callbackUrl={cidadaoUrlParams.callbackUrl}
              callbackParams={cidadaoUrlParams.callbackParams}
              cadImovelCallBackParams={cidadaoUrlParams.cadImovelUrlParams}
              botaoRetornar={showBotaoRetornar}
            />
          </PageContainer>

          <CidadaoTabSection cidadao={data.cidadao} />
        </Fragment>
      )}
    </Fragment>
  )
}
